import { initTabSystem } from './utils/tabs';

document.addEventListener('DOMContentLoaded', function () {
  initTabSystem({
    tabsContainerSelector: '#by-application-tabs',
    panelsContainerSelector: '#by-application-content',
    tabSelector: '.by-application__tab',
    panelSelector: '.by-application__panel',
    bgImageSelector: '#by-application-bg-image',
    bgContainerSelector: '#by-application-bg',
  });
});
